import { render, staticRenderFns } from "./ManagerProductsView.vue?vue&type=template&id=7cc6b724&scoped=true"
import script from "./ManagerProductsView.vue?vue&type=script&lang=js"
export * from "./ManagerProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6b724",
  null
  
)

export default component.exports